import React from 'react'
import PropTypes from 'prop-types'

// import css from './styles.js'
import {
  _IconContAppLink,
} from './styles'


const AmenityWithLink = ({
  children, titlecomp, isPrint, googleAnalyticsEvent, gaSource,
  amenityLink,
}) => {
  if(!amenityLink) return ''
  return (
    <div>
      <_IconContAppLink
        openNewTab
        titlecomp={titlecomp}
        to={amenityLink.url}
        alt={amenityLink.altTxt}
        isPrint={isPrint}
        onClick={() => {
          if(gaSource && googleAnalyticsEvent) {
            googleAnalyticsEvent({
              category: gaSource,
              action: amenityLink.gaAction,
            })
          }
        }}
      >
        {children}
      </_IconContAppLink>
    </div>
  )
}

export default AmenityWithLink


AmenityWithLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.node]),
  titlecomp: PropTypes.string,
  isPrint: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  gaSource: PropTypes.string,
  amenityLink: PropTypes.shape({
    url: PropTypes.string,
    altTxt: PropTypes.string,
    gaAction: PropTypes.arrayOf(PropTypes.string),
  }),
}

